<template xmlns="http://www.w3.org/1999/html" xmlns="http://www.w3.org/1999/html">
    <div class="layout-wrapper">
        <div class="container-fluid">
            <div class="col-12">
                <div class="card shadow">
                    <div class="card-header  bg-accent-grad glow-accent text-center">
                        <h3 class="text-white">مدیریت گزارش کار روزانه پرسنل</h3>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="card-header admin-header w-100">
                                <h5 class="text-accent-light">کارکنان زیر مجموعه</h5>
                            </div>

                            <div class="col-12 input-group round mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">جستجو</span>
                                </div>
                                <input class="form-control" v-model="search" @input="searching()"
                                       placeholder="حداقل 2 کاراکتر از اسامی کارکنان را وارد کنید">
                            </div>
                            <div class="table-responsive">
                                <div v-if="!isLoading">
                                    <preloader/>
                                </div>
                                <div v-else>
                                    <div v-if="myUsers.length===0">
                                        <p class="text-center mt-3">هیچ کاربری تعریف نشده است. ابتدا کاربران را معرفی نمائید</p>

                                    </div>
                                    <div v-else>
                                        <table class="table table-hover table-striped mb-3">
                                            <thead>
                                            <tr>
                                                <th>نام</th>
                                                <th>نام خانوداگی</th>
                                                <th>نقش</th>
                                                <th class="text-center">عملیات</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="it in myUsers">

                                                <td class="text-nowrap">{{it.name}}</td>

                                                <td class="text-nowrap">{{it.family}}</td>
                                                <td class="text-nowrap">{{it.enRoleName}}</td>
                                                <td class="text-center text-nowrap"><i
                                                        class="fa fa-pencil-square-o px-3 clickable"
                                                        style="font-size: larger"
                                                        @click="editUserItem(it)"
                                                        title="ویرایش آیتم"></i>

                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--///////////////////////////////////////////////////////////////////////////////////////////////////-->
            <modal show="false" ref="insertModal" v-if="showUserDailyReports">
                <div class="card-body">

                    <div class="row">

                        <div class="card-header admin-header w-100">
                            <h1 class="text-center"> لیست گزارش کار ثبت شده توسط کارکنان</h1>

                            <!--<h5 class="text-accent-light" v-if="showArchive">(آرشیو شده)</h5>-->
                            <div class="card-header admin-header w-100">
                                <div class="text-left">
                                    <button class="btn btn-link text-accent-lightt"
                                            @click="onArchiveApprovalDailyReportsClicked()">
                                        <i class="fa fa-eye" v-if="showArchive" title="عدم نمایش آرشیو ها"></i>
                                        <i class="fa fa-eye-slash" v-else title="نمایش آرشیو ها"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="col-12 input-group round mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">جستجو</span>
                                </div>
                                <input class="form-control" v-model="search" @input="searching()"
                                       placeholder="حداقل 2 کاراکتر از سرفصل کار یا وظیفه را وارد کنید">
                            </div>
                            <div class="table-responsive">
                                <div v-if="!isLoading">
                                    <preloader/>
                                </div>
                                <div v-else>
                                    <div v-if="mydailyReports.length===0">
                                        <p class="text-center mt-3">هیچ کار یا وظیفه ای ثبت نشده است.</p>

                                    </div>
                                    <div v-else>
                                        <table class="table table-hover table-striped mb-3">
                                            <thead>
                                            <tr>
                                                <th>تاریخ</th>
                                                <th>سرفصل کار/وظیفه</th>
                                                <th>زمان انجام</th>
                                                <th>توضیحات</th>

                                                <th class="text-center">عملیات</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="it in mydailyReports">

                                                <td class="text-nowrap">{{showDateDayWork(it.day)}}</td>

                                                <td class="text-nowrap">{{it.headLineTitle}}</td>
                                                <td class="text-nowrap">{{it.totalWork}}</td>
                                                <td class="text-wrap">{{it.description}}</td>
                                                <td class="text-center text-nowrap"><i
                                                        class="fa fa-pencil-square-o px-3 clickable"
                                                        style="font-size: larger"
                                                        @click="editItem(it)"
                                                        title="تایید یا رد آیتم"></i>


                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </modal>
            <!--///////////////////////////////////////////////////////////////////////////////////////////////////-->
            <modal show="false" ref="insertModal"  v-if="showApprovalUserDailyReport">
                <div class="row p-3">
                    <div class="col-12 text-center">
                        <h1 v-if="dailyReportMode === 'create'">ثبت گزارش</h1>
                        <h1 v-else>ویرایش گزارش</h1>
                    </div>
                    <div class="col-lg-3 mb-3">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">تاریخ گزارش</span>
                            </div>
                            <date-picker type="date" format="jYYYY/jMM/jDD"
                                         :auto-submit="true"
                                         ref="newstartDate" style="flex: 1">
                                <slot>
                                    <input v-model="newstartDate"
                                           class="form-control date-input flex-grow-1"  readonly="true">
                                </slot>
                            </date-picker>
                        </div>
                    </div>
                    <div class="col-lg-4 mb-3">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">سرفصل کار/وظیفه</span>
                            </div>
                            <input class="form-control" readonly="true" v-model="filtertitleWork">
                        </div>
                    </div>
                    <div class="col-lg-2 mb-3">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">از ساعت</span>
                                <input type="number" class="form-control"  readonly="true" v-model="fromtime"
                                    @input="onChangeFromTime">
                            </div>
                        </div>
                    </div>
                    <small class="text-right">{{this.displayfromtime}}</small>
                    <div class="col-lg-2 mb-3">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">تا ساعت</span>
                                <input type="number" class="form-control"  readonly="true"  v-model="totime"
                                       @input="onChangeToTime">
                            </div>
                        </div>
                    </div>
                    <small class="text-right">{{this.displaytotime}}</small>
                    <div class="col-lg-2 mb-3">
                        <div class="input-group round ">
                            <div class="input-group-prepend" >
                                <span class="input-group-text" >مدت انجام کار</span>
                            </div>
                            <input class="form-control" readonly="true" v-model="displaytotalWork">
                        </div>
                    </div>
                    <div class="col-lg-12 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">سایر توضیحات</span>
                            </div>
                            <input class="form-control"  readonly="true" v-model="dailyReportModel.description">
                        </div>
                    </div>




                    <div class="col-lg-3 mb-2">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">تاریخ بررسی</span>
                            </div>
                            <date-picker type="date" format="jYYYY/jMM/jDD" @input="onCreateDatePicked"
                                         :auto-submit="true"
                                         ref="managerApprovalDate" style="flex: 1">
                                <slot>
                                    <input v-model="managerApprovalDate"
                                           class="form-control date-input flex-grow-1" readonly="true"
                                           @click="toggleCreateDatePicker">
                                </slot>
                            </date-picker>
                        </div>
                    </div>

                    <div class="col-lg-6 mb-1">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">تائید یا رد گزارش </span>
                            </div>
                            <vs-select @onSearch="onDropDownFocused"
                                       @onSearchBlurred="onDropDownBlurred"
                                       ref="evidence"
                                       :data="enConfirm"
                                       :mode="'create'"
                                       :selected-val="filtermanagerconfirm"
                                       :header="{multiple: false, label: 'title'}"
                                       aria-placeholder=""
                                       @onChange="onfilterConfirmChange"></vs-select>
                        </div>
                    </div>

                    <div class="col-lg-12 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">توضیحات مدیریت</span>
                            </div>
                            <input class="form-control"  v-model="dailyReportModel.managerDescription">
                        </div>
                    </div>

                    <div class="col-lg-6 offset-lg-3 text-center">
                        <button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"
                                @click="updatedailyReport" v-if="dailyReportMode==='edit'">ویرایش گزارش
                        </button>
                        <!--<button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"-->
                                <!--@click="createdailyReport" v-else>ثبت گزارش-->
                        <!--</button>-->
                        <button class="btn btn-primary btn-round clickable mt-3 mx-3"
                                @click="canceldailyReport">انصراف
                        </button>
                    </div>
                </div>
            </modal>
            <!--////////////-->

        </div>
    </div>
</template>

<script>
    import BaseService from "../../_framework/api/BaseService";
    import Moment from 'moment-jalali';
    import DatePicker from '../../_framework/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';
    import VsSelect from "../../_framework/VsSelect";
    import Utils from "../../_framework/utils/Utils";
    import Constants from "../../_framework/Constants";

    export default {
        name: "ApprovalDailyReports",
        components: {VsSelect, DatePicker},
        data() {
            return {
                max : 2400,
                min : 0,
                showArchive: false,
                showUserDailyReports :false,
                showApprovalUserDailyReport :false,
                isSending: false,
                isLoading: false,
                mytitleWorks : [],
                mydailyReports : [],
                enConfirm : [],
                filtermanagerconfirm :"",
                managerApprovalDate :"",
                myUsers :[],
                dailyReportMode: "",

                dailyReportModel: {
                    id: 0,
                    description: "",
                    day : "",
                    fromTime : "",
                    toTime : "",
                    totalWork : "",
                    titleWorkId : "",
                    bossId :"",
                    bossApprovalDate : "",
                    managerId : "",
                    managerApprovalDate: "",
                    companyId: 0,

                },
                search: "",


                fromtime : "",
                totime : "",
                displayfromtime : "",
                displaytotime : "",
                displaytotalWork : "",
                titleWorks: [],
                newstartDate : '',
                newfromDate : '',
                filtertitleWork: "",
                hFrom : 0,
                hTo : 0,
                mFrom : 0,
                mTo : 0,
                totaltime : 0,
                HourTotal : 0,
                MinuteTotal : 0,
                timecheck : '',
                row : 0,
                userId :0,
            }
        },
        mounted() {

            this.gettitleWorks();
            this.getMyUsers();
            this.getEnConfirm();
           /* this.getMytitleWorks();
            this.DisplayTotalWork();
            this.CheckTime(0);
            this.showDateDayWork('');
            this.showRowWork();
            this.calctTotalWork('');
*/
        },
        methods: {

            getEnConfirm() {
                new BaseService("enum", "/GetEnConfirm").getList().then(response => {
                    this.enConfirm = response.data;
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },

            getMyUsers() {
                new BaseService("User", "/GetSubSubordinateUsers").getList().then(response => {
                    this.myUsers = response.data;
                    this.isLoading = true;
                }).catch(error => {

                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            gettitleWorks() {
                new BaseService("titleWorks", "/GettitleWork").getList().then(response => {
                    this.titleWorks = response.data;
                }).catch(error => {

                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            getMytitleWorks() {
                new BaseService("titleWorks", "/GettitleWork").getList().then(response => {
                    this.mytitleWorks = response.data;
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            onfilterConfirmChange(val) {
                if (val && val.title ) {
                    this.filtermanagerconfirm = val.title;

                    this.dailyReportModel.managerConfirm = val.value;
                } else {

                }
            },
            editUserItem(item)
            {
                this.userId=item.id ;
                this.showUserDailyReports=true;
                this.showApprovalUserDailyReport=false;
                new BaseService("dailyReports", `/SearchDailyReportsById/${item.id}`).getList().then(response => {
                    this.mydailyReports = response.data;

                    this.isLoading = true;
                    this.$refs.insertModal.showModal();
                }).catch(error => {
                    this.isLoading = false;
                    this.showUserDailyReports=false;
                    this.showApprovalUserDailyReport=false;
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            editContinueUserItem(item)
            {

                if(item) {
                    this.userId = item;
                    this.showUserDailyReports = true;
                    this.showApprovalUserDailyReport = false;
                    new BaseService("dailyReports", `/SearchDailyReportsById/${item}`).getList().then(response => {
                        this.mydailyReports = response.data;

                        this.isLoading = true;
                        this.$refs.insertModal.showModal();
                    }).catch(error => {
                        this.isLoading = false;
                        this.showUserDailyReports = false;
                        this.showApprovalUserDailyReport = false;
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                }
            },
            editItem(item) {
                this.filtermanagerconfirm="";
                this.managerApprovalDate="";



                this.dailyReportModel = item;
                this.filtertitleWork =item.headLineTitle;

                this.newstartDate =  this.gregorianToJalaliBeautified(item.day, false);


                this.displayfromtime = item.fromTime.toString().substr(11,5);
                this.displaytotime = item.toTime.toString().substr(11,5);
                this.displaytotalWork = item.totalWork.toString();
                this.fromtime = this.displayfromtime.replace(":","");
                this.totime = this.displaytotime.replace(":","");
                this.totaltime =item.totalWork.toString();
                this.HourTotal =Math.trunc(parseInt(this.totaltime)/60);
                this.MinuteTotal= (this.totaltime % 60).toString();
                if(parseInt(this.HourTotal)<10) this.HourTotal="0"+this.HourTotal;
                if(parseInt(this.MinuteTotal)<10) this.MinuteTotal="0"+this.MinuteTotal;
                this.displaytotalWork =((this.HourTotal.toString()+":"+this.MinuteTotal).replace("-","")).replace("-","");
                if(parseInt(this.totaltime)<0) {
                    this.displaytotalWork ="-"+this.displaytotalWork;
                }
                this.dailyReportModel.totalWork=this.totaltime;

                this.totalWork = this.displaytotalWork.replace(":","");
                this.dailyReportMode = "edit";

                this.dailyReportModel.managerApprovalDate = item.managerApprovalDate;
                if(item.managerApprovalDate){
                    this.managerApprovalDate = this.gregorianToJalaliBeautified(item.managerApprovalDate,false);
                }


                this.showManagerConfirm(item);

                this.showApprovalUserDailyReport=true;
                this.showUserDailyReports=false;
                this.$refs.insertModal.showModal();
            },
            showManagerConfirm(item){
              for(let con of this.enConfirm)
              {
                  if(con.value ===item.managerConfirm)
                  {
                      this.filtermanagerconfirm=con.title;
                  }
              }
            },

            updatedailyReport() {
                this.isSending = true;
                this.dailyReportModel.fromTime =this.dailyReportModel.day.toString().substr(0,10)+" "+this.displayfromtime.toString()
                this.dailyReportModel.toTime =this.dailyReportModel.day.toString().substr(0,10)+" "+this.displaytotime.toString()

                this.dailyReportModel.fromTime =  Moment(this.dailyReportModel.fromTime).format('YYYY/MM/DD HH:mm');
                this.dailyReportModel.toTime =  Moment(this.dailyReportModel.toTime).format('YYYY/MM/DD HH:mm');
                this.dailyReportModel.totalWork=this.totaltime;

                new BaseService("dailyReports", "/UpdateDailyReportsManagerConfirm").update(this.dailyReportModel).then(response => {
                    this.$noty.success("گزارش با موفقیت تائید شد");
                    this.isSending = false;

                    this.showUserDailyReports=true;
                    this.showApprovalUserDailyReport=false;
                    this.editContinueUserItem(this.userId);
                }).catch(error => {
                    this.isSending = false;
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                    this.$refs.insertModal.hideModal();

                });


            },

            canceldailyReport() {
                this.showUserDailyReports=true;
                this.showApprovalUserDailyReport=false;
                this.filtermanagerconfirm="";
                this.managerApprovalDate="";


            },
            onArchiveApprovalDailyReportsClicked(){
                if (this.showArchive) {
                    this.showArchive = false;
                    let item = this.userId;
                    new BaseService("dailyReports", `/SearchDailyReportsById/${item}`).getList().then(response => {
                        this.mydailyReports = response.data;
                        this.isLoading = true;
                    }).catch(error => {
                        this.isLoading = false;
                        this.showUserDailyReports=false;
                        this.showApprovalUserDailyReport=false;
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });

                } else {
                    this.showArchive = true;
                    let  item="";
                    item=this.userId;
                    new BaseService("dailyReports", `/SearchArchDailyReportsById/${item}`).getList().then(response => {
                        this.mydailyReports = response.data;
                        this.isLoading=true;

                    }).catch(error => {

                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });

                }

            },
            searching() {
                if (this.search.length > 2) {
                    this.isLoading = false;
                    new BaseService("dailyReports", `/SearchdailyReports/${this.search}`).getList().then(response => {
                        this.mydailyReports = response.data;
                        this.isLoading = true;
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                } else {

                }
            },


            showDateDayWork(val){
                if(val ) {
                    return (this.gregorianToJalaliBeautified(val, false));
                }
            },
            showRowWork(){

                return(parseInt(this.row));
            },
            calctTotalWork(val) {
                return(val.toString().substr(11,5))
            },

            onCreateDatePicked(val) {

                this.managerApprovalDate = Moment(val, 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                this.dailyReportModel.managerApprovalDate = this.jalaliToGregorian(val);


            },
            toggleCreateDatePicker() {
                this.$refs.managerApprovalDate.togglePicker();
            },

            onChangeFromTime() {
                this.fromtime=this.CheckTime(this.fromtime);
                let amount = this.fromtime;
                if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {

                    this.displayfromtime = amount.toString().replace(/\B(?=(\d{2})+(?!\d))/g, ":");
                    if(parseInt(amount)<1000)
                    {
                        this.displayfromtime = "0"+amount.toString().replace(/\B(?=(\d{2})+(?!\d))/g, ":");

                    }
                } else {
                    this.displayfromtime = amount;
//                    this.dailyReportModel.fromTime = this.fromtime;
                }
                this.DisplayTotalWork();
            },
            onChangeToTime() {
               this.totime =this.CheckTime(this.totime);
                let amount = this.totime;
                if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {

                    this.displaytotime = amount.toString().replace(/\B(?=(\d{2})+(?!\d))/g, ":");
                    if(parseInt(amount)<1000)
                    {
                        this.displaytotime = "0"+amount.toString().replace(/\B(?=(\d{2})+(?!\d))/g, ":");
                    }
                } else {
                    this.displaytotime = amount;
                }
                this.DisplayTotalWork();

            },
            DisplayTotalWork() {
                if(parseInt(this.fromtime)>0 && parseInt(this.totime)>0 && this.fromtime.length>2 && this.totime.length>2)
                {
                    this.hFrom = this.displayfromtime.substr(0,2);
                    this.mFrom =  this.displayfromtime.substr(3,2);
                    this.hTo = this.displaytotime.substr(0,2);
                    this.mTo =  this.displaytotime.substr(3,2);
                    this.totaltime =  parseInt(this.hTo)*60 +parseInt(this.mTo)
                        - parseInt(this.hFrom)*60  -  parseInt(this.mFrom);
                    this.HourTotal =Math.trunc(parseInt(this.totaltime)/60);
                    this.MinuteTotal= (this.totaltime % 60).toString();
                    if(parseInt(this.HourTotal)<10) this.HourTotal="0"+this.HourTotal;
                    if(parseInt(this.MinuteTotal)<10) this.MinuteTotal="0"+this.MinuteTotal;
                    this.displaytotalWork =((this.HourTotal.toString()+":"+this.MinuteTotal).replace("-","")).replace("-","");
                    if(parseInt(this.totaltime)<0) {
                        this.displaytotalWork ="-"+this.displaytotalWork;
                    }
                }
            },
            CheckTime(val) {
                this.timecheck = val;
                if(parseInt(this.timecheck)>this.max)
                {
                    if(parseInt(this.timecheck.toString().substr(0,2))>=24)
                    {
                        this.timecheck=this.max;
                    }
                    else if(parseInt(this.timecheck.toString().substr(4,2))>=60)
                    {

                        this.timecheck =val.toString().substr(0,2)+"59";
                    }
                    else
                    {
                        this.timecheck = this.timecheck.toString().substr(0, 4);

                    }
                }
                else
                {

                    if(this.timecheck.toString().length>3 )
                    {
                        if( parseInt(this.timecheck.toString().substr(2,2))>=60) {

                            this.timecheck = this.timecheck.toString().substr(0, 2) + "59";
                        }
                    }
                }
                return( this.timecheck);
            }

        }
    }
</script>

<style lang="scss" scoped>
    .profile-image {
        margin: 0 auto 1rem auto;
    }

    .profile-image img {
        max-width: 150px;
        border-radius: 1rem;
        box-shadow: 0 10px 25px -10px rgba(0, 0, 0, 0.25);
    }
</style>